import React from "react";
import "./style.scss";
import "../../style/typography.scss";
import { useSelector } from "react-redux";
import { State } from "../../app/store";
import { useTranslation } from "react-i18next";


const Seller: React.FC = () => {
  const configuration = useSelector((state: State) => state.config.configuration);
  const { t } = useTranslation();

  // const { config } = useOldConfiguration();

  return (
    <React.Fragment>
      <div>
        {/* {config && <b>{config.logoUrl}</b>} */}
    
    {configuration.facilityName && configuration.facilityName.length > 3 && <p>Administratorem danych osobowych <b>{configuration.facilityName}  </b>
  Dane przetwarzane będą w celu realizacji zamówienia, sprzedaży biletów oraz realizacji obowiązków prawnych związanych z umową sprzedaży.  
  Więcej o tym jak przetwarzamy dane osobowe można znaleźć tutaj: 
  {configuration.regulaminList[0] &&   <a href={configuration.regulaminList[0].file}  target="_blank">Polityka prywatności</a>}
</p>}



{configuration.facilityPhone !== "" && configuration.helpDetails !== "" && <p>
  Masz pytania dotyczące oferty lub zamówienia ? Skontaktuj się: 

  {configuration.helpDetails && <b className="marginLeft">{configuration.helpDetails}</b> }  

  {configuration.facilityPhone &&<b className="marginLeft">{configuration.facilityPhone}</b> }
  
  
</p>}







       
       
        {/* <article>{t("sprzedawca_jest_xyz_masz_pytania_odnoscie_oferty_napisz_na")} </article> */}

        {/* {regulaminList && 
          <ul>
            {regulaminList.map((item, index) => (
              <li key={index}>
                <a href={item.file} target="_blank">
                  {item.name}
                </a>
              </li>
            ))}
          </ul>
        )} */}
      </div>
    </React.Fragment>
  );
};

export default Seller;
